import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Input } from 'antd';

// Actions
import {
    onChangePassword,
    onChangePasswordError,
    onChangePasswordModalIsLoading
} from '../../data/auth/actions';
// Constants
import { MODAL_SIZES } from '../../constants/modal';
// Selectors
import {
    getUserChangePasswordHasError,
    getUserChangePasswordErrorText
} from '../../data/auth/selectors';

class ChangePasswordModal extends PureComponent {

    constructor(props){
        super(props);
        const {
            onChangePasswordModalIsLoading
        } = props;
        onChangePasswordModalIsLoading(false);
    }

    handleSubmit = () => {
        const { form, onChangePasswordError } = this.props;

        onChangePasswordError(false, null);

        form.validateFields((err, values) => {

            const {msgs} = this.props;

            if (err) {
                return;
            }

            if (values.password.length < 8) {
                onChangePasswordError(true, msgs.auth.passPolicyLength);
                return;
            }
            const upperCase = /(?=.*?[A-Z])/;
            if (upperCase.test(values.password) === false) {
                onChangePasswordError(true, msgs.auth.passPolicyUpperCase);
                return;
            }
            const lowerCase = /(?=.*?[a-z])/;
            if (lowerCase.test(values.password) === false) {
                onChangePasswordError(true, msgs.auth.passPolicyLowerCase);
                return;
            }
            const number = /(?=.*?[0-9])/;
            if (number.test(values.password) === false) {
                onChangePasswordError(true, msgs.auth.passPolicyNumber);
                return;
            }
            if (values.password !== values.confirmPassword) {
                onChangePasswordError(true, msgs.auth.passAndConfirmDontMatch);
                return;
            }

            const { onChangePassword, userId } = this.props;

            onChangePassword(userId, values.password).catch(() => {
                form.setFieldsValue({
                    hasError: msgs.homes.editHomeError
                });
            });
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    handleCancel = () => {
        const {onCancel, onChangePasswordError} = this.props;
        onChangePasswordError(false, null);
        onCancel();
    };

    render() {
        const {
            form,
            isShown,
            isLoading = false,
            msgs,
            hasError,
            errorText
        } = this.props;

        const { getFieldValue, getFieldDecorator } = form;
        return (
            <Modal
                key="admin-auth-change-password"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.auth.changePassword}
                onCancel={this.handleCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        {hasError && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={errorText}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.auth.newPasswordLabel}>
                                    {getFieldDecorator('password', {
                                        initialValue: "",
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="password" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.auth.confirmPasswordLabel}>
                                    {getFieldDecorator('confirmPassword', {
                                        initialValue: "",
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="password" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        isLoading: state.auth.getIn(['changePasswordModal', 'isLoading']),
        userId: state.auth.getIn(['user', 'data', 'id']),
        isShown: state.auth.getIn(['changePasswordModal', 'isShown']),
        hasError: getUserChangePasswordHasError(state),
        errorText: getUserChangePasswordErrorText(state)
    }),
    {
        onChangePassword,
        onChangePasswordError,
        onChangePasswordModalIsLoading
    }
)(Form.create()(ChangePasswordModal));
